// @ts-nocheck
/**
 * The Bamboo Walk - Theme JavaScript
 * Version 1.0
 */

(function() {
  'use strict';

  // ============================================
  // PAGE LOAD ANIMATION
  // ============================================
  function initPageLoad() {
    const pageLoad = document.getElementById('pageLoad');
    if (!pageLoad) return;

    const chars = pageLoad.querySelectorAll('.load-char');
    const line = pageLoad.querySelector('.load-line');
    const sub = pageLoad.querySelector('.load-sub');

    let delay = 0;
    chars.forEach((char, i) => {
      setTimeout(() => char.classList.add('in'), delay);
      delay += 80;
    });

    setTimeout(() => line && line.classList.add('in'), delay);
    setTimeout(() => sub && sub.classList.add('in'), delay + 400);

    setTimeout(() => {
      pageLoad.classList.add('done');
      document.querySelectorAll('.hero-h .split-text').forEach((el, i) => {
        setTimeout(() => {
          el.classList.add('in');
          const chars = el.querySelectorAll('.char');
          let charDelay = 0;
          chars.forEach(c => {
            setTimeout(() => c.classList.add('in'), charDelay);
            charDelay += 35;
          });
        }, i * 300);
      });
    }, delay + 1200);
  }

  // ============================================
  // HEADER - Transparent at top, solid on scroll
  // ============================================
  function initHeader() {
    const hdr = document.getElementById('hdr');
    if (!hdr) return;

    window.addEventListener('scroll', () => {
      hdr.classList.toggle('sc', window.scrollY > 50);
    });
  }

  // ============================================
  // SCROLL PROGRESS BAR
  // ============================================
  function initScrollProgress() {
    const prog = document.getElementById('prog');
    if (!prog) return;

    window.addEventListener('scroll', () => {
      const scrolled = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      prog.style.width = scrolled + '%';
    });
  }

  // ============================================
  // SCROLL REVEAL ANIMATION
  // ============================================
  function initScrollReveal() {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('[data-reveal]').forEach(el => revealObserver.observe(el));

    // Stagger animation
    const staggerObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('[data-stagger]').forEach(el => staggerObserver.observe(el));
  }

  // ============================================
  // PINNED ORIGINS SECTION
  // ============================================
  function initPinnedOrigins() {
    const pinWrap = /** @type {HTMLElement|null} */ (document.querySelector('.pin-wrap'));
    if (!pinWrap) return;

    const panels = document.querySelectorAll('.pin-panel');
    const dots = document.querySelectorAll('.pin-dot');
    const progressFill = document.getElementById('pinProgressFill');
    const progressTxt = document.querySelector('.pin-progress-txt');
    const totalPanels = panels.length;

    function updatePanel() {
      const rect = pinWrap.getBoundingClientRect();
      const wrapHeight = pinWrap.offsetHeight;
      const windowHeight = window.innerHeight;
      const scrolled = -rect.top;
      const scrollable = wrapHeight - windowHeight;
      const progress = Math.min(Math.max(scrolled / scrollable, 0), 1);
      const currentPanel = Math.floor(progress * totalPanels) + 1;
      const clampedPanel = Math.min(Math.max(currentPanel, 1), totalPanels);

      panels.forEach((p, i) => p.classList.toggle('active', i + 1 === clampedPanel));
      dots.forEach((d, i) => d.classList.toggle('active', i + 1 === clampedPanel));

      const fillPercent = (clampedPanel / totalPanels) * 100;
      if (progressFill) progressFill.style.width = fillPercent + '%';
      if (progressTxt) progressTxt.textContent = String(clampedPanel).padStart(2, '0') + ' / 0' + totalPanels;
    }

    window.addEventListener('scroll', updatePanel);
    window.addEventListener('resize', updatePanel);
    updatePanel();

    dots.forEach(dot => {
      const dotEl = /** @type {HTMLElement} */ (dot);
      dotEl.addEventListener('click', () => {
        const target = parseInt(dotEl.dataset.goto || '1');
        const wrapTop = pinWrap.offsetTop;
        const panelHeight = pinWrap.offsetHeight / totalPanels;
        window.scrollTo({ top: wrapTop + (target - 1) * panelHeight, behavior: 'smooth' });
      });
    });
  }

  // ============================================
  // MOBILE MENU TOGGLE
  // ============================================
  function initMobileMenu() {
    const menuToggle = document.querySelector('.menu-toggle');
    const nav = document.querySelector('.nav');

    if (!menuToggle || !nav) return;

    menuToggle.addEventListener('click', () => {
      nav.classList.toggle('active');
      menuToggle.classList.toggle('active');
    });
  }

  // ============================================
  // SMOOTH SCROLL FOR ANCHOR LINKS
  // ============================================
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#') return;

        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // ============================================
  // BLOG CAROUSEL
  // ============================================
  function initBlogCarousel() {
    const carousel = /** @type {HTMLElement|null} */ (document.getElementById('blogsCarousel'));
    const prevBtn = /** @type {HTMLButtonElement|null} */ (document.getElementById('blogsPrev'));
    const nextBtn = /** @type {HTMLButtonElement|null} */ (document.getElementById('blogsNext'));

    if (!carousel || !prevBtn || !nextBtn) return;

    let currentIndex = 0;
    const cards = carousel.querySelectorAll('.blogs-card-new');
    const totalCards = cards.length;

    function getVisibleCards() {
      if (window.innerWidth < 750) return 1;
      if (window.innerWidth < 990) return 2;
      return 3;
    }

    function getCardWidth() {
      const firstCard = /** @type {HTMLElement|null} */ (cards[0] || null);
      if (!firstCard) return 0;
      return firstCard.offsetWidth + 24;
    }

    function updateCarousel() {
      const visibleCards = getVisibleCards();
      const maxIndex = Math.max(0, totalCards - visibleCards);
      currentIndex = Math.min(currentIndex, maxIndex);

      const offset = currentIndex * getCardWidth();
      carousel.style.transform = 'translateX(-' + offset + 'px)';

      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }

    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    });

    nextBtn.addEventListener('click', () => {
      const visibleCards = getVisibleCards();
      const maxIndex = Math.max(0, totalCards - visibleCards);
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    });

    // Touch/swipe support
    let touchStartX = 0;
    carousel.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', function(e) {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) nextBtn.click();
        else prevBtn.click();
      }
    });

    /** @type {ReturnType<typeof setTimeout>|null} */
    let resizeTimer = null;
    window.addEventListener('resize', () => {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateCarousel, 150);
    });

    updateCarousel();
  }

  // ============================================
  // INITIALIZE ALL
  // ============================================
  document.addEventListener('DOMContentLoaded', function() {
    initPageLoad();
    initHeader();
    initScrollProgress();
    initScrollReveal();
    initPinnedOrigins();
    initMobileMenu();
    initSmoothScroll();
    initBlogCarousel();
  });

})();
